function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.4 24C5.4 24.7333 6.0075 25.3333 6.75 25.3333H8.1V30C8.1 31.1067 9.0045 32 10.125 32C11.2455 32 12.15 31.1067 12.15 30V25.3333H14.85V30C14.85 31.1067 15.7545 32 16.875 32C17.9955 32 18.9 31.1067 18.9 30V25.3333H20.25C20.9925 25.3333 21.6 24.7333 21.6 24V10.6667H5.4V24ZM2.025 10.6667C0.9045 10.6667 0 11.56 0 12.6667V22C0 23.1067 0.9045 24 2.025 24C3.1455 24 4.05 23.1067 4.05 22V12.6667C4.05 11.56 3.1455 10.6667 2.025 10.6667ZM24.975 10.6667C23.8545 10.6667 22.95 11.56 22.95 12.6667V22C22.95 23.1067 23.8545 24 24.975 24C26.0955 24 27 23.1067 27 22V12.6667C27 11.56 26.0955 10.6667 24.975 10.6667ZM18.2655 2.88L20.0205 1.14667C20.2905 0.88 20.2905 0.466667 20.0205 0.2C19.7505 -0.0666667 19.332 -0.0666667 19.062 0.2L17.064 2.17333C15.9975 1.64 14.7825 1.33333 13.5 1.33333C12.204 1.33333 10.989 1.64 9.909 2.17333L7.8975 0.2C7.6275 -0.0666667 7.209 -0.0666667 6.939 0.2C6.669 0.466667 6.669 0.88 6.939 1.14667L8.7075 2.89333C6.7095 4.34667 5.4 6.68 5.4 9.33333H21.6C21.6 6.68 20.2905 4.33333 18.2655 2.88ZM10.8 6.66667H9.45V5.33333H10.8V6.66667ZM17.55 6.66667H16.2V5.33333H17.55V6.66667Z",
  fill: "#3DD109"
});

const SvgAndroid = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 27,
  height: 32,
  viewBox: "0 0 27 32",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAndroid, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/android.90671bed.svg";
export { ForwardRef as ReactComponent };